import { render, staticRenderFns } from "./EditTestuser.vue?vue&type=template&id=f8bf5592&"
import script from "./EditTestuser.vue?vue&type=script&lang=js&"
export * from "./EditTestuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports